import PropTypes from 'prop-types';

function NormalButton(props) {
  const { buttonText, action } = props;
  return (
    <button
      type="button"
      onClick={action}
      className="bg-blue-500 hover:bg-blue-700 text-white xl:text-xl lg:text-md md:text-sm text-xs py-2 md:px-4 px-2 md:mb-4 mb-2 xl:w-1/3 lg:w-1/2 w-full"
    >
      {buttonText}
    </button>
  );
}

export default NormalButton;

NormalButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};
